import adminConfig from './chart/admin'
import exploitationConfig from './chart/exploitation'
import histoveryConfig from './chart/histovery'
import partnerConfig from './chart/partner'

const chartsConfig = Object.assign(
  {},
  adminConfig,
  exploitationConfig,
  histoveryConfig,
  partnerConfig,
)

export default chartsConfig
